export const Constants = {
  Button: 'button',
  DateTime: 'dateTime',
  Date: 'date',
  UploadFile: 'Upload file',
  DragAndDrop: 'Drag and drop your file here',
  OnlyCsv: '(only .csv)',
  DownloadTemplate: 'Download Template',
  UploadTemplate: 'Upload Template',
  UploadProducts: 'Upload Products',
  Edit: 'edit',
  Single: 'single',
  ViewDataTable: 'View Data Table',
  Error: 'error',
  Info: 'info',
  CSV: '.csv',
  Uploading: 'uploading',
  Complete: 'complete',
  CategoryProducts: 'categoryProducts',
  UploadedProducts: 'uploadedProducts',
  UploadStoresFile: 'Upload stores file',
  UploadError: 'Upload Error',
  CorruptedFile: 'Corrupted File',
  Cancel: 'Cancel',
  BulkModifiers: 'bulkPointModifiers',
  SalesTargetMedia: 'salesTargetMedia',
  Public: 'public',
  Private: 'private',
  Multipart: 'multipart',
  Required: 'required',
  Success: 'Success',
  ErrorForFileUpload: 'Error while uploading file.',
}

export const NUMBERS = {
  OneThousandTwentyFour: 1024,
  Fifty: 50,
  Hundred: 100,
  Zero: 0,
}

export const Size = {
  Medium: 'medium',
}

export const SCHEDULE_DROPDOWN = {
  NOW: 'now',
  CUSTOM_SCHEDULE: 'custom schedule',
  END_OF_MONTH: 'end of month',
  END_OF_YEAR: 'end of year',
}
export const Variant = {
  Primary: 'primary',
  Secondary: 'secondary',
}

export const SELECTION_TYPE = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
  NONE: 'none', //to be removed after fixes
}

export const LABELS = {
  ORDER_ITEM_OVERVIEW_PAGE: {
    SubItems: 'Sub Items',
    TransactionDetails: 'Transaction Details',
    DiscountInformation: 'Discount Information',
  },
}

export const API_VERSION = {
  V1: 'v1',
  V2: 'v2',
}

export const DATE_VALIDATION_TYPE = {
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  SCHEDULE: 'schedule',
  SCHEDULE_YEAR: 'schedule_year',
}


export const DATE_VALIDATION_MESSAGE = {
  END_DATE_HELPER_TEXT: 'Please select start date before selecting end date.',
  CAN_NOT_BE_GREATOR_THAN_END_DATE: "can't be greater than end date",
}
export const orderType = {
  OFFLINE: 'OFFLINE',
  ONLINE: 'ONLINE',
  REFUND: 'REFUND',
  REWARDS: 'REWARDS',
}

export const ORDER_STATUS = {
  COMPLETED: 'completed',
  PARTIALLY_DELIVERED: 'partially_delivered',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
  PENDING: 'pending',
  REFUNDED: 'refunded',
  PARTIALLY_REFUNDED: 'partially_refunded',
  PARTIAL_APPROVED: 'partial_approved',
  REJECTED: 'rejected',
}

export const ORDER_STATUS_TAGS = {
  COMPLETED: 'completed-tag',
  CANCELLED: 'cancelled-tag',
  DEFAULT: 'default-tag',
}

export const ORDER_STATUS_COLORS = {
  BADGE_GREEN:  'order-status-completed',
  BADGE_ORANGE: 'order-status-cancelled',
  DEFAULT:      'order-status-default',
  WHITE:        'order-status-white',
  BADGE_YELLOW: 'order-status-rejected',
  BADGE_RED:    'order-status-badge-red',
}

export const ORDER_LIST_CONTEXT = {
  ONLINE: 'online',
  REFUND: 'refund',
}

export const REWARD_ALLOWED_STATUS_OPTIONS = ['Delivered', 'Not Delivered', 'Cancelled', 'In Progress']

export const BOOLEAN_DROPDOWN_OPTIONS = [
  {id: 'true', displayText: 'True'},
  {id: 'false', displayText: 'False'},
]
